import './style.css'

const EmptyView = () => {
    return (
        <div className='emptyView-wrap'>
        <img src='/images/gif/empty.gif' alt='' />
      </div>
    );
};

export default EmptyView;